import React from "react";
import { Col, Row, Typography, Image, Button, Space } from "antd";
import myPic from "../../pics/Passport.jpg";
import { AuditOutlined, BuildOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import TypingText from "../../helpers/TypingText";
import ReactHelmet from "../../helpers/ReactHelmet";

const { Paragraph, Text } = Typography;
function Home({ screenWidth }) {
  const navigate = useNavigate();
  return (
    <Paragraph
      style={{
        padding: "1rem 1rem 0.5rem 1rem",
        display: "flex",
        alignItems: "center",
        height: "82vh",
        // background: "#940",
      }}
    >
      <ReactHelmet
        title="Portfolio"
        content={`A brief insight about what Jamir Muhumuza does as  Full-Stack engineer, Front-end Developer or Software Engineer`}
      />
      <Paragraph>
        <Row align="middle" style={{ width: "100%" }}>
          <Col md={16}>
            {screenWidth < 800 && (
              <Paragraph style={{ textAlign: "center", marginTop: "4rem" }}>
                <Image
                  src={myPic}
                  style={{
                    width: "100%",
                    height: "30vh",
                    borderRadius: "50%",
                    boxShadow: "2px 2px 8px #888",
                    border: "10px solid #0abacc",
                  }}
                  preview={false}
                />
              </Paragraph>
            )}

            <Paragraph
              style={{
                textAlign: screenWidth < 800 ? "center" : "left",
                padding: "1rem 0",
                lineHeight: 1,
                margin: 0,
              }}
            >
              <Text style={{ fontSize: "1.4rem", lineHeight: 0.2 }}>
                Hi, It's me
              </Text>
              <br />
              <Text
                strong
                style={{
                  fontSize: screenWidth > 800 ? "2.9rem" : "24px",
                  color: "#0abacc",
                  lineHeight: 1.5,
                }}
              >
                JAMIR MUHUMUZA
              </Text>
            </Paragraph>
            <TypingText
              text="SOFTWARE ENGINEER AND UX/UI DESIGNER"
              speed={120}
              screenWidth={screenWidth}
            />
            <Paragraph
              style={{
                margin: "0.5rem 0",
                fontSize: screenWidth > 800 && "1.3rem",
                wordWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              I am a results-driven Software Engineer who places a strong
              emphasis on user satisfaction. My expertise lies in crafting
              effective websites, applications, and platforms that drive
              competitiveness and revenue growth.
            </Paragraph>
            <Paragraph style={{ padding: "2rem 0" }}>
              <Space size={15}>
                <Button
                  type="primary"
                  icon={<AuditOutlined />}
                  onClick={() => navigate("/projects")}
                  style={{ padding: "1rem 1.5rem", borderRadius: "30px" }}
                >
                  View Projects
                </Button>
                <Button
                  icon={<BuildOutlined />}
                  style={{ padding: "1rem 1.5rem", borderRadius: "30px" }}
                >
                  Hire me!
                </Button>
              </Space>
            </Paragraph>
          </Col>
          {screenWidth > 800 && (
            <Col md={8} style={{ textAlign: "center" }}>
              <Image
                src={myPic}
                style={{
                  width: "100%",
                  height: "40vh",
                  borderRadius: "50%",
                  boxShadow: "2px 1px 20px #0c6f8d",
                  border: "10px solid #0abacc",
                }}
                preview={false}
              />
            </Col>
          )}
        </Row>
      </Paragraph>
    </Paragraph>
  );
}

export default Home;
